var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "extra-items": [{
        text: _vm.customer.name,
        to: 'CustomerDetailView',
        params: {
          customerID: this.customer.id
        }
      }, '編輯']
    }
  })], 1)]), _c('b-card', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('div', {
    staticClass: "row mb-2 align-items-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("會員資料編輯 - " + _vm._s(_vm.customer.name))])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b-form-group', {
    attrs: {
      "disabled": _vm.readonly
    }
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_vm._v(" 來源通路: " + _vm._s(_vm.customer.merchant.type_name) + "(" + _vm._s(_vm.customer.merchant.name) + ") ")]), _vm.fieldIsVisible('name') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayName('name', '名稱')
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": _vm.readonlyFields('name')
    },
    model: {
      value: _vm.customer.name,
      callback: function callback($$v) {
        _vm.$set(_vm.customer, "name", $$v);
      },
      expression: "customer.name"
    }
  })], 1) : _vm._e(), _vm.fieldIsVisible('outer_code') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayName('outer_code', '識別編號')
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": _vm.readonlyFields('outer_code')
    },
    model: {
      value: _vm.customer.outer_code,
      callback: function callback($$v) {
        _vm.$set(_vm.customer, "outer_code", $$v);
      },
      expression: "customer.outer_code"
    }
  })], 1) : _vm._e(), _vm.fieldIsVisible('mobile_phone') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayName('mobile_phone', '手機')
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": _vm.readonlyFields('mobile_phone')
    },
    model: {
      value: _vm.customer.mobile_phone,
      callback: function callback($$v) {
        _vm.$set(_vm.customer, "mobile_phone", $$v);
      },
      expression: "customer.mobile_phone"
    }
  })], 1) : _vm._e(), _vm.fieldIsVisible('phone_verified_at') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayName('phone_verified_at', '手機驗證時間')
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "clear-button": "",
      "disabled": _vm.readonlyFields('phone_verified_at')
    },
    model: {
      value: _vm.customer.phone_verified_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.customer.phone_verified_at, "date", $$v);
      },
      expression: "customer.phone_verified_at.date"
    }
  })], 1), _c('div', {
    staticClass: "ml-2 w-50"
  }, [_c('vue-timepicker', {
    attrs: {
      "placeholder": "選擇時間",
      "disabled": _vm.readonlyFields('phone_verified_at')
    },
    model: {
      value: _vm.customer.phone_verified_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.customer.phone_verified_at, "time", $$v);
      },
      expression: "customer.phone_verified_at.time"
    }
  })], 1)])]) : _vm._e(), _vm.fieldIsVisible('email') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayName('email', 'E-mail')
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": _vm.readonlyFields('email')
    },
    model: {
      value: _vm.customer.email,
      callback: function callback($$v) {
        _vm.$set(_vm.customer, "email", $$v);
      },
      expression: "customer.email"
    }
  })], 1) : _vm._e(), _vm.fieldIsVisible('email_verified_at') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayName('email_verified_at', 'Email 驗證時間')
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "clear-button": "",
      "disabled": _vm.readonlyFields('email_verified_at')
    },
    model: {
      value: _vm.customer.email_verified_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.customer.email_verified_at, "date", $$v);
      },
      expression: "customer.email_verified_at.date"
    }
  })], 1), _c('div', {
    staticClass: "ml-2 w-50"
  }, [_c('vue-timepicker', {
    attrs: {
      "placeholder": "選擇時間",
      "disabled": _vm.readonlyFields('email_verified_at')
    },
    model: {
      value: _vm.customer.email_verified_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.customer.email_verified_at, "time", $$v);
      },
      expression: "customer.email_verified_at.time"
    }
  })], 1)])]) : _vm._e(), _vm.fieldIsVisible('sexual') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayName('sexual', '性別')
    }
  }, [_c('b-form-radio-group', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.sexualOptions,
      "value-field": "value",
      "text-field": "text",
      "disabled": _vm.readonlyFields('sexual')
    },
    model: {
      value: _vm.customer.sexual,
      callback: function callback($$v) {
        _vm.$set(_vm.customer, "sexual", $$v);
      },
      expression: "customer.sexual"
    }
  })], 1) : _vm._e(), _vm.fieldIsVisible('birthday') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayName('birthday', '生日')
    }
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "clear-button": "",
      "disabled": _vm.readonlyFields('birthday')
    },
    model: {
      value: _vm.birthday,
      callback: function callback($$v) {
        _vm.birthday = $$v;
      },
      expression: "birthday"
    }
  })], 1) : _vm._e(), _vm.fieldIsVisible('created_at') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayName('created_at', '加入時間')
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "clear-button": !_vm.isLineCustomer,
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": _vm.readonlyFields('created_at')
    },
    model: {
      value: _vm.customer.created_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.customer.created_at, "date", $$v);
      },
      expression: "customer.created_at.date"
    }
  })], 1), _c('div', {
    staticClass: "ml-2 w-50"
  }, [_c('vue-timepicker', {
    attrs: {
      "placeholder": "選擇時間",
      "disabled": _vm.readonlyFields('created_at')
    },
    model: {
      value: _vm.customer.created_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.customer.created_at, "time", $$v);
      },
      expression: "customer.created_at.time"
    }
  })], 1)])]) : _vm._e(), _vm.fieldIsVisible('accept_term_at') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayName('accept_term_at', '條款接受時間')
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "clear-button": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh
    },
    model: {
      value: _vm.customer.accept_term_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.customer.accept_term_at, "date", $$v);
      },
      expression: "customer.accept_term_at.date"
    }
  })], 1), _c('div', {
    staticClass: "ml-2 w-50"
  }, [_c('vue-timepicker', {
    attrs: {
      "placeholder": "選擇時間"
    },
    model: {
      value: _vm.customer.accept_term_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.customer.accept_term_at, "time", $$v);
      },
      expression: "customer.accept_term_at.time"
    }
  })], 1)])]) : _vm._e(), _vm.fieldIsVisible('registered_at') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayName('registered_at', '註冊時間')
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "clear-button": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh
    },
    model: {
      value: _vm.customer.registered_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.customer.registered_at, "date", $$v);
      },
      expression: "customer.registered_at.date"
    }
  })], 1), _c('div', {
    staticClass: "ml-2 w-50"
  }, [_c('vue-timepicker', {
    attrs: {
      "placeholder": "選擇時間"
    },
    model: {
      value: _vm.customer.registered_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.customer.registered_at, "time", $$v);
      },
      expression: "customer.registered_at.time"
    }
  })], 1)])]) : _vm._e(), _vm.fieldIsVisible('credit_balance') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayName('credit_balance', '購物金')
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": _vm.readonlyFields('credit_balance')
    },
    model: {
      value: _vm.customer.credit_balance,
      callback: function callback($$v) {
        _vm.$set(_vm.customer, "credit_balance", $$v);
      },
      expression: "customer.credit_balance"
    }
  })], 1) : _vm._e(), _vm.fieldIsVisible('point_balance') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": _vm.displayName('point_balance', '點數')
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": _vm.readonlyFields('point_balance')
    },
    model: {
      value: _vm.customer.point_balance,
      callback: function callback($$v) {
        _vm.$set(_vm.customer, "point_balance", $$v);
      },
      expression: "customer.point_balance"
    }
  })], 1) : _vm._e()], 1)], 1), _c('div', {
    staticClass: "col-6"
  }, [_c('b-form-group', {
    attrs: {
      "disabled": _vm.readonly
    }
  }, [_vm._l(_vm.fields, function (field, index) {
    return [!field.isHidden ? _c('b-form-group', {
      key: 'field' + index,
      attrs: {
        "label-cols": "12",
        "label-cols-lg": "2",
        "label-size": "m",
        "content-cols": "12",
        "content-cols-lg": "6",
        "label": field.title + (field.required ? '*' : ''),
        "description": field.memo
      }
    }, [field.type === 'text' ? _c('b-form-input', {
      attrs: {
        "disabled": field.disabled,
        "placeholder": field.placeholder
      },
      model: {
        value: _vm.customer.profiles[field.matched_key],
        callback: function callback($$v) {
          _vm.$set(_vm.customer.profiles, field.matched_key, $$v);
        },
        expression: "customer.profiles[field.matched_key]"
      }
    }) : _vm._e(), field.type === 'select' ? _c('b-form-select', {
      attrs: {
        "options": field.options,
        "disabled": field.disabled,
        "placeholder": field.placeholder
      },
      model: {
        value: _vm.customer.profiles[field.matched_key],
        callback: function callback($$v) {
          _vm.$set(_vm.customer.profiles, field.matched_key, $$v);
        },
        expression: "customer.profiles[field.matched_key]"
      }
    }) : _vm._e(), field.type === 'radio' ? _c('b-form-radio-group', {
      attrs: {
        "options": field.options,
        "disabled": field.disabled
      },
      model: {
        value: _vm.customer.profiles[field.matched_key],
        callback: function callback($$v) {
          _vm.$set(_vm.customer.profiles, field.matched_key, $$v);
        },
        expression: "customer.profiles[field.matched_key]"
      }
    }) : _vm._e(), field.type === 'checkbox' ? _c('b-form-checkbox-group', {
      attrs: {
        "options": field.options,
        "disabled": field.disabled
      },
      model: {
        value: _vm.customer.profiles[field.matched_key],
        callback: function callback($$v) {
          _vm.$set(_vm.customer.profiles, field.matched_key, $$v);
        },
        expression: "customer.profiles[field.matched_key]"
      }
    }) : _vm._e(), field.type === 'tags' ? _c('b-form-tags', {
      attrs: {
        "input-id": "tags",
        "placeholder": field.placeholder,
        "size": "lg",
        "tag-variant": "dark",
        "remove-on-delete": "",
        "separator": " ,;",
        "addButtonText": "新增"
      },
      model: {
        value: _vm.customer.profiles[field.matched_key],
        callback: function callback($$v) {
          _vm.$set(_vm.customer.profiles, field.matched_key, $$v);
        },
        expression: "customer.profiles[field.matched_key]"
      }
    }) : _vm._e(), field.type === 'textarea' ? _c('b-form-textarea', {
      staticClass: "liff-reservation-form__textarea",
      attrs: {
        "rows": "5"
      },
      model: {
        value: _vm.customer.profiles[field.matched_key],
        callback: function callback($$v) {
          _vm.$set(_vm.customer.profiles, field.matched_key, $$v);
        },
        expression: "customer.profiles[field.matched_key]"
      }
    }) : _vm._e(), field.type === 'date' ? _c('datepicker', {
      class: {
        'open-up': index >= 3
      },
      attrs: {
        "bootstrap-styling": "",
        "format": "yyyy-MM-dd",
        "language": _vm.zh,
        "placeholder": field.placeholder
      },
      model: {
        value: _vm.customer.profiles[field.matched_key],
        callback: function callback($$v) {
          _vm.$set(_vm.customer.profiles, field.matched_key, $$v);
        },
        expression: "customer.profiles[field.matched_key]"
      }
    }) : _vm._e(), _vm.v$.customer.profiles[field.matched_key].$error ? _c('div', {
      staticClass: "text-danger mt-2",
      staticStyle: {
        "font-size": ".75rem"
      },
      attrs: {
        "id": field.matched_key
      }
    }, [_vm._v(" " + _vm._s(_vm.v$.customer.profiles[field.matched_key].$errors[0].$message) + " ")]) : _vm._e()], 1) : _vm._e()];
  })], 2)], 1)]), !_vm.readonly ? _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [[_vm._v("返回")]], 2), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [[_vm._v("確認編輯")]], 2)], 1) : _vm._e()])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }